module.exports = __webpack_public_path__ + "static/media/search.0278c590.svg";